import React, { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import Helmet from 'react-helmet';
// import { Partytown } from '@builder.io/partytown/react';
import CabModifySearch from '../../components/CabModifySearch/CabModifySearch';
import WhyBookWithUs from '../../components/WhyBookWithUs/WhyBookWithUs';
import FaqSection from '../../components/Faq/Faq';
import RentalCabPrice from '../../components/RentalCabPrice/RentalCabPrice';
import RentalCabs from '../../components/RentalCabs/RentalCabs';
import TopCabsRoutes from '../../components/TopCabsRoutes/TopCabsRoutes';
import Footer from '../../components/Footer/Footer';
import BreadCrumb from '../../components/BreadCrumb/BreadCrumb';
import PageHeader from '../../components/PageHeader/PageHeader';
import DataLoaderError from '../../../server/errors/DataLoaderError';
import AppContextProvider from '../../AppContext';
import CompactList from '../../components/CompactList/CompactList';
import capitalise from '../../utils/capitalise';
import { trackCityOperatorTemplateEvent } from '../../../src/utils/omnitureTracking';
import './CityOperatorTemplate.css';
import { EnvironmentVariables } from '../../types';
import { getAppEnv } from '../../../config/env';
import Overlay from '../../components/BPG/Overlay';
import { useKnowMoreDetails } from '../customHooks';
import AdsComponent from '../../components/adsComponent';
import { SEO_CITY_OPERATOR_TEMPLATE } from '../../constants/templateConstants';
import { yeildToMainThread } from '../../scheduler';
import { useSearchWidgetHooks } from '../../utils/commonUtils';

const env = getAppEnv();
const { DATA_LOADER_URL, PUBLIC_URL } = env.raw as EnvironmentVariables;
const isSSR = typeof window === 'undefined';

const CityOperatorTemplate = ({ data }) => {
  const isMobileDevice = useMediaQuery({
    query: '(max-device-width: 768px)'
  });
  const [
    selectedKnowMoreDetailsForMobile,
    setSelectedKnowMoreDetailsForMobile
  ] = useKnowMoreDetails(null, isMobileDevice);
  const delayedKnowMoreDetailsForMobile = async val => {
    await yeildToMainThread(() => setSelectedKnowMoreDetailsForMobile(val));
  };

  const { cityData, templateData, operatorData } = data;
  const {
    name: cityName,
    topRoutesfromCity,
    cabTypesAvailableForRent,
    cabRentalPrices,
    otherCitiesWithGivenOperator,
    otherCities,
    airportsUrlList
  } = cityData;
  const { name: operatorName = '' } = operatorData;
  const operatorNameCapitalised = capitalise(operatorName);
  const { travelFor, pickUpTime, dropTime } = useSearchWidgetHooks(
    SEO_CITY_OPERATOR_TEMPLATE
  );
  return (
    <AppContextProvider
      omniUrlArgs={`source=${SEO_CITY_OPERATOR_TEMPLATE}`}
      trackTemplateEvent={trackCityOperatorTemplateEvent}
      selectedKnowMoreDetailsForMobile={selectedKnowMoreDetailsForMobile}
      setSelectedKnowMoreDetailsForMobile={delayedKnowMoreDetailsForMobile}
    >
      <div
        className={`cabSeoDtPage ${
          selectedKnowMoreDetailsForMobile ? 'expanded' : ''
        }`}
      >
        <Helmet>
          <title>{templateData.metaTitle}</title>
          <meta name="description" content={templateData.metaDescription} />
          <meta name="keywords" content={templateData.metaKeywords} />
          <link rel="canonical" href={templateData.sampleUrl} />
        </Helmet>
        {/* <Partytown
          debug={true}
          forward={['dataLayer.push', 'gtag']}
          lib={`${PUBLIC_URL}/static/public/partytown/`}
        /> */}
        <div className={`desktopShow makeSticky`}>
          <CabModifySearch
            pickupTime={pickUpTime}
            defaultTripType={travelFor}
            returnTime={dropTime}
            isMobileDevice={false}
            title={`${cityName} Cabs`}
          />
        </div>
        <div className={`mobileShow makeSticky`}>
          <CabModifySearch
            pickupTime={pickUpTime}
            defaultTripType={travelFor}
            returnTime={dropTime}
            isMobileDevice={true}
            title={`${cityName} Cabs`}
          />
        </div>
        <main className="container">
          <BreadCrumb breadcrumb={templateData.breadcrumb} />
          <PageHeader
            title={templateData.h1Title.replace(
              operatorName,
              operatorNameCapitalised
            )}
            extraInfo={templateData.extraInfo}
            isMobileDevice={isMobileDevice}
          />
          <div className="appendBottom40">
            {
              <AdsComponent
                template={'City_Operator'}
                placedAt={'top'}
                isMobileDevice={isMobileDevice}
                desktopAdConfig={{
                  position: templateData.bannerDesktop
                    ? templateData.bannerDesktop
                    : 'none',
                  class: 'desktopShow appendBottom20 adsLayout',
                  style: {}
                }}
                mobileAdConfig={{
                  position: templateData.bannerMobile
                    ? templateData.bannerMobile
                    : 'none',
                  class: 'mobileShow appendBottom20 adsLayout',
                  style: { marginTop: null }
                }}
              />
            }
            {templateData?.usps?.length > 0 && (
              <section className="bookWithUsWrap visibilityAuto">
                <h2>{`Why to Book ${cityName} ${operatorNameCapitalised} with Us`}</h2>
                <WhyBookWithUs usps={templateData.usps} />
              </section>
            )}
          </div>
          {topRoutesfromCity.cabTypes.length > 0 && (
            <TopCabsRoutes
              h2={`Top ${operatorNameCapitalised} Routes from ${cityName}`}
              cityName={cityName}
              operatorName={operatorNameCapitalised}
              routeType="From"
              data={topRoutesfromCity}
            />
          )}
          <RentalCabs
            h2={`Rental ${
              operatorName ? operatorNameCapitalised + ' ' : ''
            }in ${cityName}`}
            cityName={cityName}
            operatorName={operatorNameCapitalised}
            data={cabTypesAvailableForRent}
          />
          {/* {mySafetyHtmls.ePassUsp && (
            <div className=" appendBottom40">
              <EpassBnr html={mySafetyHtmls.ePassUsp} />
            </div>
          )}
          <br style={{ display: 'none' }} /> */}

          {/*https://github.com/contra/react-responsive/issues/162*/}
          {/* {mySafetyHtmls.stateGuidelines && (
            <section>
              <h2>State Guidelines on e-Passes</h2>
              <StateGuidelines html={mySafetyHtmls.stateGuidelines} />
            </section>
          )} */}
          <div className={`cabsSeoWrap__Details makeFlex visibilityAuto`}>
            {otherCities && otherCities.length > 0 && (
              <CompactList
                titlePrefix={`Taxi Services in Other Cities `}
                titleSuffix={``}
                list={otherCities}
                type={'bullets'}
                className={'appendRight20'}
              >
                {(item: any, idx, style) => (
                  <li
                    key={`${item.name}_${idx}`}
                    className={`${
                      idx ? `paddingT10 paddingB10` : `paddingB10`
                    }`}
                  >
                    {item.url ? (
                      <a
                        className={`linkBoxFont `}
                        onClick={() => {
                          trackCityOperatorTemplateEvent(
                            `Cab_SEO_Taxi Services in Other Cities_Link_Click`
                          );
                        }}
                        href={item.url}
                      >
                        {item.name}
                      </a>
                    ) : (
                      <span>{item.name}</span>
                    )}
                  </li>
                )}
              </CompactList>
            )}

            {otherCitiesWithGivenOperator &&
              otherCitiesWithGivenOperator.length > 0 && (
                <CompactList
                  titlePrefix={`${operatorNameCapitalised} in Other cities`}
                  titleSuffix={``}
                  list={otherCitiesWithGivenOperator}
                  type={'bullets'}
                  className={'appendRight20'}
                >
                  {(item: any, idx, style) => (
                    <li
                      key={`${item.name}_${idx}`}
                      className={`${
                        idx ? `paddingT10 paddingB10` : `paddingB10`
                      }`}
                    >
                      {item.url ? (
                        <a
                          className={`linkBoxFont `}
                          onClick={() => {
                            trackCityOperatorTemplateEvent(
                              `Cab_SEO_${operatorName} Cabs in Other Cities_Link_Click`
                            );
                          }}
                          href={item.url}
                        >
                          {item.name}
                        </a>
                      ) : (
                        <span>{item.name}</span>
                      )}
                    </li>
                  )}
                </CompactList>
              )}
            {airportsUrlList && airportsUrlList.length > 0 && (
              <CompactList
                titlePrefix={`Our Airport Cabs  `}
                titleSuffix={``}
                list={airportsUrlList}
                type={'bullets'}
                className={'appendRight20'}
              >
                {(item: any, idx, style) => (
                  <li
                    key={`${item.name}_${idx}`}
                    className={`${
                      idx ? `paddingT10 paddingB10` : `paddingB10`
                    }`}
                  >
                    {item.url ? (
                      <a
                        className={`linkBoxFont`}
                        onClick={() => {
                          trackCityOperatorTemplateEvent(
                            `Cab_SEO_Our Airport Cabs_Link_Click`
                          );
                        }}
                        href={item.url}
                      >
                        {item.name}
                      </a>
                    ) : (
                      <span>{item.name}</span>
                    )}
                  </li>
                )}
              </CompactList>
            )}
          </div>
          <section className="visibilityAuto">
            <h2>{`Frequently Asked Questions About ${cityName} ${
              operatorName ? operatorNameCapitalised + ' ' : ''
            }Booking`}</h2>
            <FaqSection
              trackTemplateEvent={trackCityOperatorTemplateEvent}
              data={templateData.faq}
              pageUrl={templateData.sampleUrl}
            />
          </section>
          {cabRentalPrices && cabRentalPrices.length > 0 ? (
            <section>
              <h2>{`${cityName} ${
                operatorName ? operatorNameCapitalised + ' ' : ''
              }Rental Cabs Prices`}</h2>
              <RentalCabPrice cabRentalPrices={cabRentalPrices} />
            </section>
          ) : null}
        </main>
        {selectedKnowMoreDetailsForMobile ? (
          <Overlay
            cancelButton={() => delayedKnowMoreDetailsForMobile(null)}
            knowMoreDetails={selectedKnowMoreDetailsForMobile}
          />
        ) : null}
        <Footer template={templateData} />
        <div
          className="blackOverlay"
          onClick={() => {
            delayedKnowMoreDetailsForMobile(null);
          }}
        ></div>
      </div>
    </AppContextProvider>
  );
};

CityOperatorTemplate.fetchData = async (_, match, urlObj) => {
  const {
    params: { cityCode, operatorCode }
  } = match;
  const url = `${DATA_LOADER_URL}/api/cityOperatorTemplateData/${cityCode}/${operatorCode}?${urlObj.query}`;
  let responseData;

  const response = await fetch(url);
  const textResponse = await response.text();

  try {
    responseData = JSON.parse(textResponse);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('url', url);
    throw new Error('JSON parse exception: ' + textResponse);
  }
  if (responseData.status !== 'SUCCESS') {
    // eslint-disable-next-line no-console
    console.error('url', url);
    throw new DataLoaderError(
      `Unable to fetch city details of ${cityCode}`,
      responseData.error
    );
  }
  return responseData;
};
export default CityOperatorTemplate;
